import { loadModules } from 'esri-loader';
import React from 'react';
import ReactDOM from 'react-dom';
import { ISWSParcelAttributes } from '../landchars/BSLAParcelLayer';
import format from 'number-format.js'; // https://github.com/Mottie/javascript-number-formatter
import BSLAGetCounty from '../../helpers/BSLAFIPSLookup';
import BSLAGetAssesorLink from '../../helpers/BSLAPropertyLinks';
import BSLAExternalLinkComponent from '../../helpers/BSLAExternalLinkComponent';

const BSLAParcelPopup = async (view: __esri.MapView | __esri.SceneView) => {
    type popupModules = [typeof import('esri/PopupTemplate')];
    const [PopupTemplate] = await (loadModules(['esri/PopupTemplate']) as Promise<popupModules>);

    return new PopupTemplate({
        title: 'Parcel {apn}',
        content: (feature: __esri.Feature) => {
            const node = document.createElement('div');
            const atts = feature.graphic.attributes as ISWSParcelAttributes;
            const address = atts.stdAddr;
            const countyInfo = BSLAGetCounty(parseInt(atts.stateCode, 10), parseInt(atts.countyCode, 10));

            const assessorLink = BSLAGetAssesorLink({
                county: countyInfo[0].county_name,
                state: countyInfo[0].state_name,
                apn: atts.apn
            });

            const content = (
                <React.Fragment>
                    {atts.owner ? <div>{atts.owner}</div> : null}
                    {address ? <div>{address}</div> : null}
                    <div>
                        {atts.city}, {atts.state} {atts.zip}
                    </div>
                    {countyInfo[0] ? <div>{countyInfo[0].county_name} County</div> : null}
                    <div>{format('#,##0.00', atts.area_ac)} Acres ±</div>
                    {assessorLink ? <BSLAExternalLinkComponent href={assessorLink} /> : null}
                </React.Fragment>
            );

            ReactDOM.render(content, node);

            return node;
        }
    });
};

export default BSLAParcelPopup;
